import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { bottom } from '@popperjs/core';
// import * as d3 from 'd3';
import { Chart } from 'chart.js/auto';
@Component({
  selector: 'ipm-pie',
  templateUrl: './pie.component.html',
  styleUrls: ['./pie.component.scss']
})
export class PieComponent implements OnInit, AfterViewInit {
  @Input() chartId: string = "";
  @Input() chartData: any = "";
  @Input() type: string = "";

  makeBarChart () {
    let chartOptions: any = {
      type: 'pie',
      data: {
        datasets: [{
          backgroundColor: [
            'rgba(122, 95, 253, 1)',
            'rgba(199, 150, 251,1)',
            'rgba(232, 192, 253,1)'
          ],
          hoverOffset: 4
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
              display: true,
              position: 'bottom',
              align:"center",
              maxWidth: 100
          }
        },
        elements: {
          arc: {
              borderWidth: 0
          }
        }
      }
    }
    if (this.chartData) {
      let labels: Array<any> = [];
      let data: Array<any> = [];
      this.chartData.map((chartOp: any) => {
        labels.push(chartOp.licenceTitle);
        let dateValue =  this.type === "volume" ? chartOp.count : chartOp.value;
        data.push(dateValue)
      });
      chartOptions.data.labels =  labels;
      chartOptions.data.datasets[0].data =  data;
    }
    return chartOptions;
  }

  constructor() { }

  ngOnInit(): void {
    // if () {
    //   this.ctx = (document.getElementById('lineChart') as HTMLElement).getContext('2d'); // 2d context
    //   this.ctx = $('#lineChart'); // jQuery instance
    //   this.ctx = 'myChart';
    // }
  }

  ngAfterViewInit(): void {
  
    new Chart(this.chartId,this.makeBarChart());
  }
}
